import { defineMessages, MessageDescriptor } from 'react-intl';

export const ignoredScopes = new Set(['offline_access']);

export const filterScopes = (scopes: string[]) =>
  scopes.filter((scope) => !ignoredScopes.has(scope));
export const scopeDescriptions: Record<string, MessageDescriptor> =
  defineMessages({
    'read:deal-registration:partnercentral': {
      id: 'oauth.scopes.read-deal-registration-partnercentral',
      defaultMessage: 'Read Deal Registrations',
      description: 'Scope description for read:deal-registration:partnercentral',
    },
    'read:service-registration:partnercentral': {
      id: 'oauth.scopes.read-service-registration-partnercentral',
      defaultMessage: 'Read Service Registrations',
      description: 'Scope description for read:service-registration:partnercentral',
    },
    'read:pvr:partnercentral': {
      id: 'oauth.scopes.read-pvr-partnercentral',
      defaultMessage: 'Read PVR Records',
      description: 'Scope description for read:pvr:partnercentral',
    },
    'search:registration:partnercentral': {
      id: 'oauth.scopes.search-registration-partnercentral',
      defaultMessage: 'Search Registrations',
      description: 'Scope description for search:registration:partnercentral',
    },
    'create:deal-registration:partnercentral': {
      id: 'oauth.scopes.create-deal-registration-partnercentral',
      defaultMessage: 'Create Deal Registrations',
      description: 'Scope description for create:deal-registration:partnercentral',
    },
    'create:service-registration:partnercentral': {
      id: 'oauth.scopes.create-service-registration-partnercentral',
      defaultMessage: 'Create Service Registrations',
      description: 'Scope description for create:service-registration:partnercentral',
    },
    'create:pvr:partnercentral': {
      id: 'oauth.scopes.create-pvr-partnercentral',
      defaultMessage: 'Create PVR Records',
      description: 'Scope description for create:pvr:partnercentral',
    },
    'update:deal-registration:partnercentral': {
      id: 'oauth.scopes.update-deal-registration-partnercentral',
      defaultMessage: 'Update Deal Registrations',
      description: 'Scope description for update:deal-registration:partnercentral',
    },
    'update:service-registration:partnercentral': {
      id: 'oauth.scopes.update-service-registration-partnercentral',
      defaultMessage: 'Update Service Registrations',
      description: 'Scope description for update:service-registration:partnercentral',
    },
    'update:pvr:partnercentral': {
      id: 'oauth.scopes.update-pvr-partnercentral',
      defaultMessage: 'Update PVR Records',
      description: 'Scope description for update:pvr:partnercentral',
    },
    'submit:deal-registration:partnercentral': {
      id: 'oauth.scopes.submit-deal-registration-partnercentral',
      defaultMessage: 'Submit Deal Registrations',
      description: 'Scope description for submit:deal-registration:partnercentral',
    },
    'submit:service-registration:partnercentral': {
      id: 'oauth.scopes.submit-service-registration-partnercentral',
      defaultMessage: 'Submit Service Registrations',
      description: 'Scope description for submit:service-registration:partnercentral',
    },
    'read:partner-accounts:partnercentral': {
      id: 'oauth.scopes.read-partner-accounts-partnercentral',
      defaultMessage: 'Read Partner Accounts',
      description: 'Scope description for read:partner-accounts:partnercentral',
    },
    'read:jobs:partnercentral': {
      id: 'oauth.scopes.read-jobs-partnercentral',
      defaultMessage: 'Read Jobs',
      description: 'Scope description for read:jobs:partnercentral',
    },
  });
